import { Header as Accordion, Trigger } from '@radix-ui/react-accordion';
import { Icon, IconsEnum } from 'components/Icons';

import { IppicaCurrency } from 'features/ippica/types';
import { IppicaHeaderDetailsBox } from '../../ippicaHeaderDetailsBox';
import { IppicaHeaderNumeroCorsa } from '../../ippicaHeaderNumeroCorsa/IppicaHeaderNumeroCorsa';
import { IppicaInfoListItem } from '../../ippicaInfoListItem';
import React from 'react';
import { convertInCurrencyValueByPrizeInfo } from 'utility/functions';
import styles from './IppicaHeaderInfoAccordionTrigger.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize from 'hooks/useWindowSize';

export type IppicaHeaderInfoAccordionTriggerProps = {};
// eslint-disable-next-line react/display-name
export const IppicaHeaderInfoAccordionTrigger = React.forwardRef<
  HTMLButtonElement,
  IppicaHeaderInfoAccordionTriggerProps
>(({}, forwardedRef) => {
  const { isMobile } = useWindowSize();

  const labelTipo = useGetLabelByKey('tipo-di-corsa');
  const labelDistanza = useGetLabelByKey('distanza');
  const labelPartenti = useGetLabelByKey('partenti');
  const labelMontepremi = useGetLabelByKey('montepremi');
  const {
    tipoGara,
    distanza,
    numeroCavalliPartenti,
    importoPremio,
    valutaPremio = '',
    nazione,
  } = useTypedSelector((state) => state.ippica.ippicaDetailRace!) || {};

  return (
    <Accordion className={styles.header}>
      <Trigger ref={forwardedRef} className={styles.container}>
        {!isMobile && (
          <div className={styles.firstCol}>
            <IppicaHeaderNumeroCorsa />
            <IppicaHeaderDetailsBox />
          </div>
        )}
        <ul className={styles.list}>
          <IppicaInfoListItem className={styles.title} title={labelTipo!} textType={'medium'}>
            {tipoGara ? tipoGara : '-'}
          </IppicaInfoListItem>
          <IppicaInfoListItem className={styles.title} title={labelDistanza!} textType={'medium'}>
            {distanza ? `${distanza}m` : '-'}
          </IppicaInfoListItem>
          <IppicaInfoListItem className={styles.title} title={labelPartenti!} textType={'medium'}>
            {numeroCavalliPartenti ? numeroCavalliPartenti : '-'}
          </IppicaInfoListItem>
          <IppicaInfoListItem className={styles.title} title={labelMontepremi!} textType={'medium'}>
            {!importoPremio
              ? 'N.D.'
              : convertInCurrencyValueByPrizeInfo(importoPremio, {
                  nation: nazione,
                  currencyPrize: valutaPremio as IppicaCurrency | '',
                })}
          </IppicaInfoListItem>
        </ul>
        <Icon iconId={IconsEnum.CHEVRON_DOWN} className={styles.icon} color="var(--color-primary)" />
      </Trigger>
    </Accordion>
  );
});
